import React from 'react'
import { Modal } from '@components/ui'

type MessageCenterDeleteContactGroupModalProps = {
  show: boolean
  groupName: string
  onCancel: () => void
  onDelete: () => void
}

const MessageCenterDeleteContactGroupModal: React.FC<
  MessageCenterDeleteContactGroupModalProps
> = ({ show, groupName, onCancel, onDelete }) => {
  const name = groupName.trim() || 'this'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title="Delete contact group"
      description={`Are you sure you want to delete the ${name} group? This action can't be undone.`}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      onPrimaryClick={onDelete}
      onSecondaryClick={onCancel}
    />
  )
}

export default MessageCenterDeleteContactGroupModal
